import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const ServerStatusPage: React.FC = () => {
  const theme = useTheme();
  
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h2" sx={{ 
        fontWeight: 700, 
        color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#000000',
        fontSize: '3rem', // Twice the size of h4 (1.5rem * 2)
        mb: 3
      }}>
        Server Status
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Server status monitoring functionality will be implemented here.
      </Typography>
    </Box>
  );
};

export default ServerStatusPage;
